
import { createReducer } from '@reduxjs/toolkit' ;
import { setDateRange, setSelectedRadioOption } from '../actions/dateRangeActions';

const initialState = {
  startDate: null,
  endDate: null,
  selectedOption: 'Last Week',
};


const dateRangeReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(setDateRange, (state, action) => {
	  		const { startDate, endDate } = action.payload;
	  		state.startDate = startDate;
	  		state.endDate = endDate;
			  sessionStorage.setItem('startDate', state.startDate);
			  sessionStorage.setItem('endDate', state.endDate);
	}).addCase(setSelectedRadioOption, (state, action) => {
		const { selectedOption } = action.payload;
		state.selectedOption = selectedOption; 
		sessionStorage.setItem('selectedOption', state.selectedOption);
	});
	builder.addDefaultCase((state) => state); 
});

export default dateRangeReducer;
